export default __webpack_public_path__ + "static/call-icon-02698ab14ff5855138b02590ee00ee15.png";